export default __webpack_public_path__ + "static/grandy-3c852084f080d81ba41320c2cbea0a56.jpg";